import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=30ca0a5f&scoped=true"
import script from "./Achievement.vue?vue&type=script&lang=js"
export * from "./Achievement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ca0a5f",
  null
  
)

export default component.exports